import { Injectable } from '@angular/core';

import { STORAGE_KEYS } from '../constants/storage-keys.constant';

/**
 * Preferencia "menú colapsado" en `localStorage`. Si el storage no está
 * disponible o lanza (modo privado estricto, cuota llena), se asume expandido
 * y el error no se propaga para no romper el layout.
 */
@Injectable({ providedIn: 'root' })
export class SidebarStateService {
  getCollapsed(): boolean {
    try {
      return localStorage.getItem(STORAGE_KEYS.sidebarCollapsed) === 'true';
    } catch {
      return false;
    }
  }

  setCollapsed(collapsed: boolean): void {
    try {
      localStorage.setItem(STORAGE_KEYS.sidebarCollapsed, String(collapsed));
    } catch {
      // Sin storage la preferencia solo dura la sesión actual.
    }
  }
}
